import styled, {css} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Form} from 'components/ui-kit/Form';
import {Hint} from 'components/ui-kit/Hint';
import {Input} from 'components/ui-kit/Input';
import {NativeInput} from 'components/ui-kit/Input/styled';
import {Modal} from 'components/ui-kit/Modal';
import {DialogContent, DialogTitle} from 'components/ui-kit/Modal/styled';
import {breakpoint, colors} from 'theme';

import {Select} from '../../../../ui-kit/Select';

export const CustomModal = styled(Modal)`
    ${DialogTitle} {
        font-size: 18px;
        text-align: left;
        font-weight: 500;
        margin-left: 6px;
    }

    ${DialogContent} {
        @media (min-width: ${breakpoint.tablet}) {
            width: 100vw;
            padding: 30px 24px;

            max-width: min(100vw - 30px, 400px);
        }
    }
`;

export const FormRoot = styled(Form)`
    display: flex;
    flex-flow: column nowrap;
`;

export const FactoryWrapper = styled.div`
    margin: 10px 0;
    &:last-of-type {
        border-bottom: 1px solid #ccc;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;
    margin-bottom: 10px;

    > span {
        font-size: 12px;
        color: ${colors.textMuted};
        padding-bottom: 6px;
    }

    @media (min-width: ${breakpoint.tablet}) {
        margin-bottom: unset;
    }
`;

export const CustomInput = styled(Input)`
    ${NativeInput} {
        background-color: ${colors.background};
        border: none;
        border-radius: 6px;
        padding: 14px 20px;
        font-size: 12px;

        ::placeholder {
            color: ${colors.textMuted};
        }
    }
`;

export const FactoryCreateSelect = styled(Select)`
    padding-bottom: 6px;

    & > .react-select__control {
        background-color: #f2f6ff;
    }
`;

export const FactoryLinesContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    margin-top: 10px;
`;

export const LineContainer = styled.div`
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    gap: 20px;

    & > * {
        flex: 1;
    }
`;

export const ControlContainer = styled.div<{disabled?: boolean}>`
    flex: 0 1 auto;
    padding: 5px;
    cursor: pointer;
    ${({disabled}) =>
        disabled &&
        css`
            pointer-events: none;
            cursor: default;
            opacity: 0.3;
        `}
`;

export const FactoryHeadContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
`;

export const AddMoreButton = styled(Button)`
    align-self: flex-start;
    width: auto;
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
`;

export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-top: 30px;
    gap: 20px;
`;

export const CancelModal = styled(Modal)`
    ${DialogContent} {
        margin: 20vh auto;

        @media (min-width: ${breakpoint.tablet}) {
            width: 60vw;
            max-width: 360px;
            padding: 30px 24px;
        }

        p {
            text-align: center;
            font-size: 18px;
            font-weight: 500;
        }
    }
`;

export const CancelCloseButton = styled(Button)`
    color: ${colors.white};
    background-color: ${colors.danger};
    border: 1px solid ${colors.danger};
`;

export const CancelButton = styled(Button)`
    color: ${colors.danger};
    border: 1px solid ${colors.danger};
`;
